import { render, staticRenderFns } from "./PosturasByIdSpecimenItem.vue?vue&type=template&id=655ab376"
import script from "./PosturasByIdSpecimenItem.vue?vue&type=script&lang=js"
export * from "./PosturasByIdSpecimenItem.vue?vue&type=script&lang=js"
import style0 from "./PosturasByIdSpecimenItem.vue?vue&type=style&index=0&id=655ab376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports